import { useEffect, useState } from 'react'
import './Hero.css'
import image1 from '../../assests/image3.png'
import { motion } from 'framer-motion'
import { Link } from 'react-scroll'
import { FaChevronDown } from 'react-icons/fa'

const Hero = () => {
  const [typedText, setTypedText] = useState('')
  const [textIndex, setTextIndex] = useState(0)

  useEffect(() => {
    const texts = [
      'const role = "Software Engineer";',
      '<FullStackDeveloper />',
      'import { Passion, Code } from "life";',
      'git commit -m "Build cool things"'
    ]
    const typeText = () => {
      const currentText = texts[textIndex]
      if (typedText === currentText) {
        setTimeout(() => {
          setTypedText('')
          setTextIndex((prevIndex) => (prevIndex + 1) % texts.length)
        }, 1800)
      } else if (typedText.length < currentText.length) {
        setTypedText(currentText.slice(0, typedText.length + 1))
      }
    }
    const typeInterval = setInterval(typeText, 90)
    return () => clearInterval(typeInterval)
  }, [typedText, textIndex])

  const handleDownloadResume = () => {
    const link = document.createElement('a')
    link.href = 'PasinduPerera_Resume.pdf'
    link.download = 'PasinduPerera_Resume.pdf'
    link.click()
  }

  return (
    <section className="hero" id="home">
      <div className="hero__bg-shapes">
        <div className="hero__shape hero__shape--1" />
        <div className="hero__shape hero__shape--2" />
        <div className="hero__shape hero__shape--3" />
      </div>
      <div className="hero__container">
        <div className="hero__left">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="hero__status"
          >
            <span className="hero__status-dot" />
            <span className="hero__status-text">Available for work</span>
          </motion.div>
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.05 }}
            className="hero__greeting"
          >
            Hello, I'm
          </motion.span>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="hero__name"
            data-text="Pasindu Perera"
          >
            <span className="hero__name-text">Pasindu Perera</span>
          </motion.h1>
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="hero__title"
          >
            {typedText}
            <span className="hero__cursor">|</span>
          </motion.span>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="hero__description"
          >
            I design and build scalable web apps, APIs, and systems. Focused on clean architecture, performance, and great developer experience.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="hero__actions"
          >
            <Link to="contact" spy smooth offset={-70} duration={500}>
              <button className="hero__btn hero__btn--primary">
                Get In Touch
              </button>
            </Link>
            <button className="hero__btn hero__btn--secondary" onClick={handleDownloadResume}>
              Download CV
            </button>
          </motion.div>
        </div>
        <motion.div
          className="hero__right"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <div className="hero__image-wrapper">
            <img src={image1} alt="Pasindu Perera" className="hero__image" />
          </div>
        </motion.div>
      </div>
      <motion.div
        className="hero__scroll-down"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.6 }}
      >
        <Link to="educations" spy smooth offset={-70} duration={500}>
          <span className="hero__scroll-text">Scroll Down</span>
          <FaChevronDown className="hero__scroll-icon" />
        </Link>
      </motion.div>
    </section>
  )
}

export default Hero
